import { render, staticRenderFns } from "./TimeElec.vue?vue&type=template&id=7c57c541&scoped=true"
import script from "./TimeElec.vue?vue&type=script&lang=js"
export * from "./TimeElec.vue?vue&type=script&lang=js"
import style0 from "./TimeElec.vue?vue&type=style&index=0&id=7c57c541&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c57c541",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c57c541')) {
      api.createRecord('7c57c541', component.options)
    } else {
      api.reload('7c57c541', component.options)
    }
    module.hot.accept("./TimeElec.vue?vue&type=template&id=7c57c541&scoped=true", function () {
      api.rerender('7c57c541', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widget/deWidget/TimeElec.vue"
export default component.exports